import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PTLSharedModule } from '../shared/shared.module';
import { NgxPrintModule } from 'ngx-print';
import { TransferEmployerCloseOfficeModule } from './transfer-employer-close-office/transfer-employer-close-office.module';
import { ViewPendingApprovalsModule } from './view-pending-approvals/view-pending-approvals.module';
import { SeverEmploymentModule } from './sever-employment/sever-employement.module';
import { ChangeEmployerModule } from './change-employer/change-employer.module';
import { BrokerAuditDeclarationModule } from './broker-audit-declaration/broker-audit-declaration.module';


@NgModule({
  imports: [
     FormsModule, PTLSharedModule, NgxPrintModule, ViewPendingApprovalsModule
    , TransferEmployerCloseOfficeModule, ChangeEmployerModule, SeverEmploymentModule, BrokerAuditDeclarationModule
  ],
  exports : [BrokerAuditDeclarationModule]
})
export class BrokerModule { }



// WEBPACK FOOTER //
// ./src/app/broker/broker.module.ts